import { Button, type ButtonProps } from "@ui/Button"
import { type ComponentType, type SVGProps, forwardRef } from "react"

export type IconButtonProps = Omit<ButtonProps, "children"> & {
  icon: ComponentType<SVGProps<SVGSVGElement>>
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButtonComponent({ icon: Icon, ...props }, ref) {
    return (
      <Button
        ref={ref}
        variant="iconButton"
        {...props}
      >
        <Icon />
      </Button>
    )
  },
)
